import React from 'react';

const Services = () => {
  return (
    <div>
      <h1>Services</h1>
      <p>Here are the services we offer for weddings.</p>
    </div>
  );
};

export default Services;
